<template>
  <div>
    <input-field label="设备名称" v-model="data.name" :disabled="!editable"></input-field>
    <input-field label="设备地址" v-model="data.address" :disabled="!editable"></input-field>
    <select-field label="挂载接口类型" v-model="data.interfaceType" :list="[ 'RS485' ]" :disabled="!editable"></select-field>
    <select-field label="挂载接口实例" v-model="data.interface" :list="instanceList" :disabled="!editable"></select-field>
    <submit-field @click="submit" :disabled="!editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
  /** defaults example:
   * {
   *   name: 'device1',
   *   address: 1,
   *   interfaceType: 'RS485',
   *   interface: 1,
   *   interfaceInstanceList: [ { key: $name, value: $id }, ... ]
   * }
   */

  import InputField from '@/components/utils/input-field'
  import SelectField from '@/components/utils/select-field'
  import SubmitField from '@/components/utils/submit-field'

  export default {
    props: {
      defaults: {
        required: false,
        default: Object.create(null),
        type: Object
      },
      event: {
        required: false,
        default: 'interface',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    data () {
      return {
        data: {
          name: '',
          address: '',
          interfaceType: '',
          interface: 0
        }
      }
    },
    components: {
      InputField,
      SelectField,
      SubmitField
    },
    methods: {
      refresh () {
        [ 'name', 'address', 'interfaceType', 'interface' ].forEach(key => {
          this.$set(this.data, key, this.defaults[key])
        })
      },
      submit () {
        this.$emitter.emit(this.event, {
          _id: this.defaults._id,
          name: this.data.name,
          address: this.data.address,
          interfaceType: this.data.interfaceType,
          interface: this.data.interface,
          module: 'dpe-dlt645'
        })

        this.$emitter.once(`${this.event}Resp`, err => {
          if (!err) {
            this.editable = false
          }
        })
      }
    },
    created () {
      this.refresh()
    },
    watch: {
      defaults () {
        this.refresh()
      }
    },
    computed: {
      instanceList () {
        return this.defaults.interfaceInstanceList
      },
      isValid () {
//        return this.data.name && this.data.address && this.data.interfaceType && this.data.interface
        return true
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/dlt645-device.vue